import { render } from "./ticket-view-model.vue?vue&type=template&id=caf18a4e"
import script from "./ticket-view-model.vue?vue&type=script&lang=js"
export * from "./ticket-view-model.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__